import React from 'react';

import {RequiredMark} from 'src/components/required-mark';
import {
    MAX_VENDOR_DESCRIPTION_LENGTH,
    MAX_VENDOR_NAME_LENGTH,
} from 'src/modules/vendor/shared/vendorValidation';

import {Input} from '@pb/kit-component-input-v2';
import Label from '@pb/kit-component-label';
import {Textarea} from '@pb/kit-component-textarea-v2';
import Typography from '@pb/kit-component-typography';

import {
    field,
    fields,
    section,
} from '../vendor-profile.module.styl';


type Props = {
    name: string,
    description: string,
    onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onDescriptionChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void,
};

export const VendorDetails: React.FC<Props> = ({
    name,
    description,
    onNameChange,
    onDescriptionChange,
}) => (
    <div className={section}>
        <Typography variant="heading-level-3">
            Vendor Details
        </Typography>
        <div className={fields}>
            <div className={field}>
                <Label htmlFor="vendor-name-input">
                    <RequiredMark label="Name"/>
                </Label>
                <Input
                    id="vendor-name-input"
                    value={name}
                    onChange={onNameChange}
                    placeholder="Enter company name (min. 3 characters)"
                    autoComplete="off"
                    autoCorrect="off"
                    required={true}
                    maxLength={MAX_VENDOR_NAME_LENGTH}
                />
            </div>
            <div className={field}>
                <Label htmlFor="vendor-description-input">
                    Description
                </Label>
                <Textarea
                    id="vendor-description-input"
                    value={description}
                    onChange={onDescriptionChange}
                    placeholder="Describe the vendor or their data access context"
                    resizable={false}
                    maxLength={MAX_VENDOR_DESCRIPTION_LENGTH}
                    required={true}
                />
            </div>
        </div>
    </div>
);
